export default __webpack_public_path__ + "static/media/playStore.92329c41.svg";